import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { CurrentService } from '../../../services/current.service';
import { DatasService } from '../../../services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { CONTEXT } from 'src/app/enum/context';

@Component({
  selector: 'ng-hbm-bdi-oven',
  templateUrl: './oven.component.html'
})
export class OvenComponent implements OnInit {

  ovenConfigurations: any;

  @Output() onComplete: EventEmitter<void> = new EventEmitter();

  constructor(public current: CurrentService, public datas: DatasService, private gtm: GTM) { }

  async ngOnInit(): Promise<void> {
    this.gtm.trackPage(CONTEXT.KITCHEN, 'need-mapping', 'oven', this.datas.getKitchenGtmData(this.current));
    this.ovenConfigurations = await this.datas.getOvenConfigurations();
  }

  selectOvenConfiguration(ovenConfigurationRef: string) {
    this.gtm.trackEvent("click", "need-mapping", "oven-" + ovenConfigurationRef);
    this.current.ovenConfigurationRef = ovenConfigurationRef;
    this.onComplete.emit();
  }
}
